import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SysConfigService} from './sys-config.service';
import {SearchRequestDetailModel} from '../dto/search-request-detail.model';
import {SearchRequestModel} from '../dto/search-request.model';
import {ApplicantRequest} from '../../model/applicantRequestModel';
import {Observable} from 'rxjs/index';
import {MonthWiseCountModel} from '../dto/month-wise-count.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class SearchRequestService {
  requestSearchDetailsChange = new EventEmitter<SearchRequestModel[]>();
  requestCountSearchDetailsChange = new EventEmitter<MonthWiseCountModel[]>();

  private requestSearchDetailsItem: SearchRequestModel[] = [];
  private requestCountSearchDetailsItem: MonthWiseCountModel[] = [];

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });


  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  /** Search Request Details **/
  searchRequestDetails(searchRequestDTO: SearchRequestDetailModel) {
    return this.httpClient.post(this.BASE_URL + 'search-request/search', searchRequestDTO, { headers: this.headers });
  }

  /** Search Request Count **/
  searchRequestCount(searchRequestDTO: SearchRequestDetailModel){
    return this.httpClient.post(this.BASE_URL + 'search-request/searchCountMonthWise',searchRequestDTO,{headers: this.headers})
  }

  /** reset searched details **/
  clearRequestSearchDetails() {
    this.requestSearchDetailsItem = [];
    this.requestSearchDetailsChange.emit(this.requestSearchDetailsItem);
  }

  clearRequestCountSearchDetails() {
    this.requestCountSearchDetailsItem = [];
    this.requestCountSearchDetailsChange.emit(this.requestCountSearchDetailsItem);
  }

  /** set search details in the table **/
  setRequestSearchDetails(requestSearchDetails: SearchRequestModel[]) {
    this.requestSearchDetailsItem = requestSearchDetails;
    this.requestSearchDetailsChange.emit(this.requestSearchDetailsItem);
  }

  setRequestCountSearchDetails(requestCountSearchDetails: MonthWiseCountModel[]) {
    this.requestCountSearchDetailsItem = requestCountSearchDetails;
    this.requestCountSearchDetailsChange.emit(this.requestCountSearchDetailsItem);
  }

  /** get all request details **/
  getAllRequests(){
    return this.httpClient.get(this.BASE_URL + 'search-request/all');
  }

  getAllWorkflows(){
    return this.httpClient.get(this.BASE_URL + 'search-request/allworkflows');
  }

  /** Get Details by requestId **/
  getByApplicantRequestId(id: number): Observable<Object> {
    return this.httpClient.get(this.BASE_URL + 'search-request/getApplicantById/' + id );
  }

  /** Get Payment Details by requestId **/
  getPaymentDetails(refNo: number): Observable<Object> {
    return this.httpClient.get(this.BASE_URL + 'search-request/getPaymentById/' + refNo );
  }

  exportAsPDF(dto: SearchRequestModel[]): Observable<Object>{
    return this.httpClient.post(this.BASE_URL + 'search-request/exportAsPDF', dto, {responseType: 'arraybuffer'});
  }

  /** Monthly Wise details**/
  exportPdf(Monthlydto: MonthWiseCountModel[]): Observable<Object>{
    return this.httpClient.post(this.BASE_URL + 'search-request/exportPdf', Monthlydto, {responseType: 'arraybuffer'});
  }

  exportExcel(Monthlydto: MonthWiseCountModel[]): Observable<Object>{
    return this.httpClient.post(this.BASE_URL + 'search-request/exportExcel', Monthlydto, {responseType: 'arraybuffer'});
  }

  exportAsExcel(dto: SearchRequestModel[]): Observable<Object>{
    return this.httpClient.post(this.BASE_URL + 'search-request/exportAsExcel', dto, {responseType: 'arraybuffer'});
  }




}
